import React, { ReactNode, createContext, useContext } from 'react';
import { useAccount } from 'wagmi';

import { Roles } from 'src/global/constants/role.constant';
import { useGetUserRoleQuery } from 'src/store/services/role.service';

interface RolesContextValue {
  roles: Roles[];
  isLoading: boolean;
}

const RolesContext = createContext<RolesContextValue | undefined>(undefined);

export const RolesProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { address } = useAccount();
  const { data, isSuccess } = useGetUserRoleQuery(
    { address: address || '' },
    {
      skip: !address,
    },
  );

  return (
    <RolesContext.Provider value={{ roles: data?.role ? [data.role] : [], isLoading: !isSuccess }}>
      {children}
    </RolesContext.Provider>
  );
};

export const useRoles = (): RolesContextValue => {
  const context = useContext(RolesContext);
  if (!context) {
    throw new Error('useRoles must be used within a RolesProvider');
  }
  return context;
};
